import { ItemImageLocalCombination } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemImageLocalCombination/ItemImageLocalCombination";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import { ItemTotalQuantity } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemTotalQuantity/ItemTotalQuantity";
import { MediaItemEds } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemEds/MediaItemEds";
import styles from "../../../styles/common-media-styles.module.css";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import {
  Article,
  EdsData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";

interface MediaItemCardLocalCombinationInnerChildProps<
  T extends AggregatedArticle | Article,
> {
  article: T;
  shouldDisplayQuantity?: boolean;
  totalQuantityPieces?: number;
  edsData?: EdsData | null;
  itemCardRenderType?: ItemCardRenderType;
}

export const MediaItemCardLocalCombinationInnerChild = <
  T extends AggregatedArticle | Article,
>({
  article,
  shouldDisplayQuantity = false,
  totalQuantityPieces,
  edsData,
  itemCardRenderType,
}: MediaItemCardLocalCombinationInnerChildProps<T>) => {
  return (
    <>
      <ItemImageLocalCombination />
      <div className={styles["item-card-root-column"]}>
        <ItemName name={article.itemName} />
        {itemCardRenderType === ItemCardRenderType.static ? (
          <ItemNoWithCopy
            itemNo={formatProductIdWithDots(article.productArticleId)}
          />
        ) : (
          <ItemNo itemNo={formatProductIdWithDots(article.productArticleId)} />
        )}
        {shouldDisplayQuantity && totalQuantityPieces && (
          <ItemTotalQuantity totalPieces={totalQuantityPieces} />
        )}
        {edsData && <MediaItemEds edsData={edsData} />}
      </div>
    </>
  );
};
